if ($('.js-nav').length) {
    console.log('navSticky initialized');
    init();
}

function init() {

    let scrollYInitial = window.pageYOffset || document.documentElement.scrollTop;

    const header = document.querySelector('.js-nav');
    const navInner = document.querySelector('.js-nav__inner');
    const navLogoImage = document.querySelector('.js-nav__logo-image');
    const navLinks = document.querySelectorAll('.js-nav__link');
    const navLinksUnderline = document.querySelectorAll('.js-nav__link-underline');
    const hamburger = document.querySelector('.hamburger');

    changeHeaderColor();
    document.addEventListener('scroll', function() {

        const scrollY = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollY === 0) {
            // console.log('im at the top');
            animateNavUp();
        } else if (scrollY > scrollYInitial) {
            // console.log('im moving down');
            animateNavDown();
        } else if (scrollY < scrollYInitial) {
            // console.log('im moving up');
        }

        scrollYInitial = scrollY;
    }, { passive: true });

    function changeHeaderColor() {
        const headerColor = header.dataset.bg;
        document.documentElement.style.setProperty(
            "--main-bg-color",
            headerColor
        );
    }

    function animateNavUp() {
        navInner.classList.add('scroll-up');
        navLogoImage.classList.add('scroll-up');
        for (let i = 0; i < navLinks.length; i++) {
            navLinks[i].classList.add('scroll-up');
        }
        for (let i = 0; i < navLinksUnderline.length; i++) {
            navLinksUnderline[i].classList.add("scroll-up");
        }

        header.classList.remove('scroll-down');
        navInner.classList.remove('scroll-down');
        navLogoImage.classList.remove('scroll-down');
        for (let i = 0; i < navLinks.length; i++) {
            navLinks[i].classList.remove('scroll-down');
        }
        for (let i = 0; i < navLinksUnderline.length; i++) {
            navLinksUnderline[i].classList.remove('scroll-down');
        }

        if (document.body.id == 'mod-1') {
            hamburger.classList.add('white');
        }
    }

    function animateNavDown() {
        header.classList.remove('scroll-up');
        navInner.classList.remove('scroll-up');
        navLogoImage.classList.remove('scroll-up');
        for (let i = 0; i < navLinks.length; i++) {
            navLinks[i].classList.remove('scroll-up');
        }
        for (let i = 0; i < navLinksUnderline.length; i++) {
            navLinksUnderline[i].classList.remove('scroll-up');
        }

        header.classList.add('scroll-down');
        navInner.classList.add('scroll-down');
        navLogoImage.classList.add('scroll-down');
        for (let i = 0; i < navLinks.length; i++) {
            navLinks[i].classList.add('scroll-down');
        }
        for (let i = 0; i < navLinks.length; i++) {
            if (navLinksUnderline[i]) {
                navLinksUnderline[i].classList.add('scroll-down');
            }
        }

        hamburger.classList.remove('white');
    }
}
